import styled, { css } from 'styled-components';

// Import styles
import { flex, customMinResponsive, size, antModal } from 'components/styles';

// Import components
import { Link } from 'react-router-dom';
import { Modal } from 'antd';
import { Heading } from 'components/elements';

export const AuthenticationContentStyled = styled.div`
	margin: 0 auto;
	background-color: ${({ theme }) => theme.authentication.contentBg};
	border-radius: 0.8rem;
	padding: 4rem 2rem;
	text-align: center;
	width: auto;

	${customMinResponsive(
		size.xsmall,
		css`
			width: 50rem;
		`
	)}

	${customMinResponsive(
		size.medium,
		css`
			width: 77rem;
		`
	)};
`;

export const InfoWrapper = styled.div`
	${flex({ fd: 'column' })}
	margin-bottom: 1.8rem;
`;

export const HeadingStyled = styled(Heading.First)`
	color: ${({ theme }) => theme.authentication.headingColor};
`;

const baseHeading = css`
	line-height: 1.4;
	font-weight: ${({ theme }) => theme.font.medium};
`;

export const Info = styled.p`
	${baseHeading}
	color: ${({ theme }) => theme.authentication.infoColor};
	${flex()}
	font-size: 1.6rem;
	margin-bottom: 1rem;

	${customMinResponsive(
		size.xsmall,
		css`
			font-size: 1.4rem;
		`
	)}
`;

// Links wrappers for login and register bottom links
export const AuthLinksWrapper = styled.div`
	${({ justifyContent = 'center' }) => flex({ jc: justifyContent, fd: 'column' })}
	padding-top: 1rem;
	height: 5rem;

	${customMinResponsive(
		size.xsmall,
		css`
			${({ justifyContent = 'center' }) => flex({ jc: justifyContent, fd: 'row' })}
			height: 4rem;
		`
	)}
`;

export const PureottWrapper = styled.div`
	padding-top: 2rem;
	p {
		margin-bottom: 3rem;
	}
`;

export const LinkStyled = styled(Link)`
	color: ${({ theme }) => theme.authentication.linkColor};
	font-size: 1.6rem;
	letter-spacing: 0.45px;
	padding-bottom: 0.5rem;

	&:hover {
		color: ${({ theme }) => theme.authentication.linkHoverColor};
		text-decoration: underline;
	}

	${customMinResponsive(
		size.xsmall,
		css`
			padding: 0;
			font-size: 1.4rem;
		`
	)}
`;

export const ModalStyled = styled(Modal)`
	${antModal()}

	.ant-modal-content {
		padding-top: 5.4rem;

		.ant-modal-header {
			.ant-modal-title {
				color: ${({ theme }) => theme.white};
				font-weight: ${({ theme }) => theme.font.distinct};
			}
		}
	}
`;

// === Authentication Wrapper styles ===
export const baseParagraph = css`
	color: ${({ theme }) => theme.white};
	margin-bottom: 1.8rem;
	line-height: 1.4;
	font-weight: ${({ theme }) => theme.font.medium};
	font-size: 2.4rem;
`;

export const LinkWrapper = styled.div`
	display: flex;
`;
